import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    // Toggle menu
    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    // Close menu when clicking a link
    const closeMenu = () => {
        setMenuOpen(false);
    };

    // Handle scroll events to change header appearance
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
            {/* Floating Menu Button */}
            <div className={`menu-button ${menuOpen ? 'active' : ''}`} onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
            </div>
            
            {/* Overlay Navigation */}
            <div className={`overlay-menu ${menuOpen ? 'active' : ''}`}>
                <nav className="overlay-nav font uppercase">
                    <ul>
                        <li><a href="#story" onClick={closeMenu}>La nostra storia</a></li>
                        <li><a href="#locations" onClick={closeMenu}>Il Giorno del matrimonio</a></li>
                        <li><a href="#rsvp" onClick={closeMenu}>RSVP</a></li>
                        <li><a href="#honeymoon" onClick={closeMenu}>Viaggio di Nozze</a></li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;
